// extracted by mini-css-extract-plugin
export default {"page":"LoginPage_page__EiPXK","pageName":"LoginPage_pageName__PfHCA","login":"LoginPage_login__GiAkl","message":"LoginPage_message__WIM7X"};